module.exports = __webpack_public_path__ + "static/media/facebook.198e5633.png";